import { TimelineMax, TweenMax } from 'gsap';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionM() {
    const { useLang, useEffect, useRouter } = useGlobal();
    const { t } = useLang('ces2023.sectionI');
    const { locale } = useRouter();

    const Blade = {
        name: t('card1.blue_text'),
        slogan: t('card1.title'),
        img: ['08.webp', '08.jpg'],
        desc: t('card1.desc'),
        gallery: [t('card1.content1'), t('card1.content2'), t('card1.content3'), t('card1.content4'), t('card1.content5'), t('card1.content6')],
        aniTime: {
            us: [1.8, 2, 2.1, 2.2, 2.4, 2.5],
        },
    };

    const Glacier = {
        name: t('card2.blue_text'),
        slogan: t('card2.title'),
        img: ['09.webp', '09.jpg'],
        desc: t('card2.desc'),
        gallery: [t('card2.content1'), t('card2.content2'), t('card2.content3'), t('card2.content4'), t('card2.content5'), t('card2.content6')],
        aniTime: {
            us: [1.5, 1.8, 2.1, 2.2, 2.4, 2.5],
        },
    };

    const Wave2 = {
        name: t('card3.blue_text'),
        slogan: t('card3.title'),
        img: ['10.webp', '10.jpg'],
        desc: t('card3.desc'),
        gallery: [t('card3.content1'), t('card3.content2'), t('card3.content3'), t('card3.content4'), t('card3.content5'), t('card3.content6')],
        aniTime: {
            us: [1.8, 2, 2.1, 2.2, 2.4, 2.6],
        },
    };

    const animationInFn = (el: string, data: any) => {
        const scene = new ScrollMagic.Scene({
            triggerElement: el,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0.95, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 800,
        });
        const timeline = new TimelineMax();
        // 文字显示
        const tween1 = TweenMax.to(`${el} .product-name`, 0.6, { opacity: 1 });
        const tween2 = TweenMax.to(`${el} .product-slogan`, 0.6, { opacity: 1 });
        const tween3 = TweenMax.to(`${el} .product-img img`, 3, { scaleX: 1 });
        timeline.add(tween1).add(tween2, 0.1).add(tween3, 0);
        const aniTime = data.aniTime[locale] || data.aniTime.us;
        for (let i = 0; i < data.gallery.length; i++) {
            const tweenList = TweenMax.to(`${el} .list-item_${i}`, 0.4, { opacity: 1 });
            timeline.add(tweenList, aniTime[i]);
        }
        scene.setTween(timeline);
        controllerCES.addScene(scene);
    };

    const animationOutFn = (el: string, data: any) => {
        const scene = new ScrollMagic.Scene({
            triggerElement: el,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 800,
        });
        const timeline = new TimelineMax();
        // 文字显示
        const tween1 = TweenMax.to(`${el} .product-name`, 0.6, { opacity: 0 });
        const tween2 = TweenMax.to(`${el} .product-slogan`, 0.6, { opacity: 0 });
        timeline.add(tween1).add(tween2, 0.1);
        const aniTime = data.aniTime[locale] || data.aniTime.us;
        for (let i = 0; i < data.gallery.length; i++) {
            const tweenList = TweenMax.to(`${el} .list-item_${i}`, 0.4, { opacity: 0 });
            timeline.add(tweenList, aniTime[i]);
        }
        scene.setTween(timeline);
        controllerCES.addScene(scene);
    };

    useEffect(() => {
        const data = [Blade, Glacier, Wave2];
        data.forEach((item, index) => {
            animationInFn(`.ani-box_${index + 1}`, item);
            animationOutFn(`.ani-box_${index + 1}`, item);
        });
    }, []);

    return (
        <div className={styles.sectionM}>
            <div className="viewport-wrapper">
                <section className="M-top ani-box_1">
                    <div className="product-name">{Blade.name}</div>
                    <div className="product-slogan">{Blade.slogan}</div>
                    <div className="lr-box">
                        <div className="left">
                            <EFPic className="product-img" name={Blade.img} />
                        </div>
                        <div className="right">
                            <div className="text">
                                <div className="desc">{Blade.desc}</div>
                                <ul className="gallery">
                                    {Blade.gallery.map((item, index) => (
                                        <li key={index} className={`list-item_${index}`}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="M-middle ani-box_2">
                    <div className="lr-box">
                        <div className="left">
                            <div className="text">
                                <div className="desc">{Glacier.desc}</div>
                                <ul className="gallery">
                                    {Glacier.gallery.map((item, index) => (
                                        <li key={index} className={`list-item_${index}`}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="right">
                            <div className="right-pic-title">
                                <div className="product-name">{Glacier.name}</div>
                                <div className="product-slogan">{Glacier.slogan}</div>
                            </div>
                            <EFPic className="product-img" name={Glacier.img} />
                        </div>
                    </div>
                </section>
                <section className="M-bottom ani-box_3">
                    <div className="product-name">{Wave2.name}</div>
                    <div className="product-slogan">{Wave2.slogan}</div>
                    <div className="lr-box">
                        <div className="left">
                            <EFPic className="product-img" name={Wave2.img} />
                        </div>
                        <div className="right">
                            <div className="text">
                                <div className="desc">{Wave2.desc}</div>
                                <ul className="gallery">
                                    {Wave2.gallery.map((item, index) => (
                                        <li key={index} className={`list-item_${index}`}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
